import { Rect, TemplateElement } from '../templateEditor.types'

export const rectsIntersect = (a: Rect, b: Rect) =>
    a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y

export const boundingRectOf = (items: Array<Pick<Rect, 'x' | 'y' | 'w' | 'h'>>): Rect | null => {
    if (items.length === 0) {
        return null
    }

    let minX = Infinity
    let minY = Infinity
    let maxX = -Infinity
    let maxY = -Infinity

    for (const item of items) {
        minX = Math.min(minX, item.x)
        minY = Math.min(minY, item.y)
        maxX = Math.max(maxX, item.x + item.w)
        maxY = Math.max(maxY, item.y + item.h)
    }

    return { x: minX, y: minY, w: maxX - minX, h: maxY - minY }
}

/** Top-level элементы: не дети групп. */
export const isTopLevel = (element: TemplateElement) => !element.groupId

/** Для marquee: top-level, не locked, не hidden (группы включаем). */
export const canMarqueeSelect = (element: TemplateElement) => isTopLevel(element) && !element.locked && !element.hidden

export const elementsInMarquee = (elements: TemplateElement[], marquee: Rect) =>
    elements
        .filter((element) => canMarqueeSelect(element) && rectsIntersect(element, marquee))
        .map((element) => element.id)

export const toggleIdInSelection = (selectedIds: string[], id: string) =>
    selectedIds.includes(id) ? selectedIds.filter((item) => item !== id) : [...selectedIds, id]

export const primarySelectedId = (selectedIds: string[]) =>
    selectedIds.length > 0 ? selectedIds[selectedIds.length - 1] : null

/** Клик по элементу: если он в группе — выделяем группу. */
export const resolveSelectableId = (elements: TemplateElement[], id: string) => {
    const element = elements.find((item) => item.id === id)
    if (!element) {
        return id
    }
    if (element.groupId) {
        return element.groupId
    }
    return element.id
}

export const selectAllTopLevelIds = (elements: TemplateElement[]) =>
    elements.filter((element) => isTopLevel(element) && !element.locked && !element.hidden).map((element) => element.id)
